import React from 'react';

export function CloseCircle () {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      fill="none"
      viewBox="0 0 28 28"
    >
      <g filter="url(#filter0_d_234_4018)" shapeRendering="crispEdges">
        <circle cx="14" cy="11" r="10" fill="#fff" fillOpacity="0.8" />
        <circle cx="14" cy="11" r="9.5" stroke="#fff" />
      </g>
      <path
        stroke="#071C3E"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M11.5 8.5l5 5M16.5 8.5l-5 5"
      />
      <defs>
        <filter
          id="filter0_d_234_4018"
          width="28"
          height="28"
          x="0"
          y="0"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy="3" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_234_4018"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_234_4018"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}
